import { createSlice } from "@reduxjs/toolkit";
import { SellerSidebarOptions } from "../../utils/constants/sidebar";
import { reducerPaths } from "src/app/reducerPaths";

const initialState = {
  // The index is of My Garage
  activeSidebar: SellerSidebarOptions[SellerSidebarOptions.length - 2],
};

const sidebarSlice = createSlice({
  name: reducerPaths.sidebar,
  initialState,
  reducers: {
    setActiveSidebar: (state, action) => {
      state.activeSidebar = action.payload;
    },
  },
});

export const { setActiveSidebar } = sidebarSlice.actions;

export default sidebarSlice.reducer;
